/* Duelhawk Quiz 2.0, Shopify build.
   Generated by tools/build_duelhawk_quiz.py from .tmp/duelhawk/quiz/v2/logic.js.
   Do not edit by hand: edit the prototype and rebuild. */
(function () {
  'use strict';

  function boot(root) {
    var node = root.querySelector('[data-dhq-config]');
    if (!node || root.getAttribute('data-dhq-booted')) return;
    root.setAttribute('data-dhq-booted', '1');
    var CFG = JSON.parse(node.textContent);
    var DHQ = window.DHQ = {};

    /* Prices, set in the section settings. The deposit is the $199 variant behind
       the payment link, so it stays here. */
    var DEPOSIT = 199;
    var PRICE_FULL = Number(CFG.priceFull) || 2945;
    var DISCOUNT = CFG.priceDiscount == null ? 800 : Number(CFG.priceDiscount) || 0;
    var PRICE = PRICE_FULL - DISCOUNT;
    var REMAINING = PRICE - DEPOSIT;
    var money = function (n) { return '$' + n.toLocaleString('en-US'); };

    /* ---------------- media, from the section config ----------------
       Images are Shopify Files addressed by name through the manifest. Clips are
       `video` settings; a clip nobody has picked yet shows its poster frame. */
    var IMG = CFG.img || {};
    function ns(prefix) {
      var o = {};
      for (var k in IMG) if (k.indexOf(prefix) === 0) o[k.slice(prefix.length)] = IMG[k];
      return o;
    }
    var ILL = ns('ill_'), TRIED_IMG = ns('tried_'), PH = ns('ph_'), POSTER = ns('poster_');
    var FG = Object.assign(ns('fg_'), {"bstars": "data:image/svg+xml;base64,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", "icheck": "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjEyLjM3NSIgaGVpZ2h0PSI4LjkzNzUiIHZpZXdCb3g9IjAgMCAxMi4zNzUgOC45Mzc1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBpZD0iRnJhbWUgMjE0NzIyNTA4MCI+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0xMS42ODc1IDAuNjg3NUw0LjEyNSA4LjI1TDAuNjg3NSA0LjgxMjUiIHN0cm9rZT0iIzE3OTA3RiIgc3Ryb2tlLXdpZHRoPSIxLjM3NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPC9zdmc+Cg==", "iguar": "data:image/svg+xml;base64,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", "ithumb": "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjE3LjUiIGhlaWdodD0iMTcuNSIgdmlld0JveD0iMCAwIDE3LjUgMTcuNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InRodW1icy11cCI+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik01LjEwNDE3IDguMDIwODNMOC4wMjA4MyAxLjQ1ODMzQzguNjAwOTkgMS40NTgzMyA5LjE1NzM5IDEuNjg4OCA5LjU2NzYzIDIuMDk5MDRDOS45Nzc4NyAyLjUwOTI3IDEwLjIwODMgMy4wNjU2NyAxMC4yMDgzIDMuNjQ1ODNWNi41NjI1SDE0LjMzNTRDMTQuNTQ2OCA2LjU2MDExIDE0Ljc1NjIgNi42MDM3IDE0Ljk0OTEgNi42OTAyNkMxNS4xNDE5IDYuNzc2ODMgMTUuMzEzNyA2LjkwNDI5IDE1LjQ1MjQgNy4wNjM4MUMxNS41OTExIDcuMjIzMzQgMTUuNjkzNSA3LjQxMTEyIDE1Ljc1MjQgNy42MTQxNEMxNS44MTE0IDcuODE3MTYgMTUuODI1NSA4LjAzMDU3IDE1Ljc5MzggOC4yMzk1OEwxNC43ODc1IDE0LjgwMjFDMTQuNzM0OCAxNS4xNDk4IDE0LjU1ODEgMTUuNDY2OCAxNC4yOTAxIDE1LjY5NDZDMTQuMDIyMiAxNS45MjI0IDEzLjY4MDkgMTYuMDQ1NiAxMy4zMjkyIDE2LjA0MTdINS4xMDQxN001LjEwNDE3IDguMDIwODNWMTYuMDQxN001LjEwNDE3IDguMDIwODNIMi45MTY2N0MyLjUyOTg5IDguMDIwODMgMi4xNTg5NiA4LjE3NDQ4IDEuODg1NDcgOC40NDc5N0MxLjYxMTk4IDguNzIxNDYgMS40NTgzMyA5LjA5MjM5IDEuNDU4MzMgOS40NzkxN1YxNC41ODMzQzEuNDU4MzMgMTQuOTcwMSAxLjYxMTk4IDE1LjM0MSAxLjg4NTQ3IDE1LjYxNDVDMi4xNTg5NiAxNS44ODggMi41Mjk4OSAxNi4wNDE3IDIuOTE2NjcgMTYuMDQxN0g1LjEwNDE3IiBzdHJva2U9IiMxMDcwNjMiIHN0cm9rZS13aWR0aD0iMS40NTgzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPC9zdmc+Cg==", "iverified": "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjEzLjUiIGhlaWdodD0iMTMuNDg0OCIgdmlld0JveD0iMCAwIDEzLjUgMTMuNDg0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTEzLjUgNi43NUwxMi4zNDQ2IDUuMjQ0OTNMMTIuNjAzIDMuMzc1TDEwLjgzOTUgMi42NzU2OEwxMC4xNDAyIDAuOTEyMTYyTDguMjcwMjcgMS4xNzA2MUw2Ljc1IDBMNS4yNDQ5MyAxLjE1NTQxTDMuMzc1IDAuODk2OTU5TDIuNjc1NjggMi42NjA0N0wwLjkxMjE2MiAzLjM1OThMMS4xNzA2MSA1LjIyOTczTDAgNi43NUwxLjE1NTQxIDguMjU1MDdMMC44OTY5NTkgMTAuMTI1TDIuNjYwNDcgMTAuODI0M0wzLjM1OTggMTIuNTg3OEw1LjIyOTczIDEyLjMyOTRMNi43MzQ4IDEzLjQ4NDhMOC4yMzk4NiAxMi4zMjk0TDEwLjEwOTggMTIuNTg3OEwxMC44MDkxIDEwLjgyNDNMMTIuNTcyNiAxMC4xMDk4TDEyLjMxNDIgOC4yMzk4NkwxMy41IDYuNzVaTTYuMjAyNyA4LjkzOTE5TDMuOTUyNyA3LjA4NDQ2TDQuNDM5MTkgNi40OTE1NUw2LjExMTQ5IDcuODU5OEw4Ljk2OTU5IDQuNTYwODFMOS41NDczIDUuMDYyNUw2LjIwMjcgOC45MzkxOVoiIGZpbGw9IiMyREEwRjIiLz4KPC9zdmc+Cg==", "rstars": "data:image/svg+xml;base64,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"});
    /* A clip plays from, in order: a link pasted in the editor (the file as
       uploaded), the WebM or mp4 rendition of a picked video, or its HLS stream.
       Shopify turns an uploaded WebM into HLS only, which Safari plays natively
       and other browsers play through hls.js, loaded only when needed. */
    var VID = {};
    function typeOf(url) {
      var ext = (String(url).split('?')[0].match(/\.(\w+)$/) || [])[1] || '';
      return {webm: 'video/webm', mp4: 'video/mp4', mov: 'video/mp4', m3u8: 'hls'}[ext.toLowerCase()] || 'video/mp4';
    }
    Object.keys(CFG.vid || {}).forEach(function (k) {
      var v = CFG.vid[k] || {}, files = [], hls = v.hls || '';
      if (v.url) { if (typeOf(v.url) === 'hls') hls = v.url; else files.push({src: v.url, type: typeOf(v.url)}); }
      if (v.webm) files.push({src: v.webm, type: 'video/webm'});
      if (v.mp4) files.push({src: v.mp4, type: 'video/mp4'});
      if (files.length || hls) VID[k] = {files: files, hls: files.length ? '' : hls, poster: v.poster || POSTER[k] || ''};
    });
    function vsrc(v) {
      return v.files.map(function (f) { return '<source src="' + f.src + '" type="' + f.type + '">'; }).join('');
    }
    /* iClosed refuses to be framed directly (X-Frame-Options: DENY). Its own
       widget script frames it from the store's domain, and watches the page for
       .iclosed-widget elements added later, which is how this screen arrives. */
    function loadBookingWidget() {
      if (!CFG.bookingUrl || !CFG.bookingEmbed) return;
      if (document.querySelector('script[src*="iclosed.io/assets/widget.js"]')) return;
      var s = document.createElement('script');
      s.src = 'https://app.iclosed.io/assets/widget.js';
      s.async = true;
      document.head.appendChild(s);
    }
    /* iClosed's frame posts its height once the calendar has drawn itself: that is
       when the loading state over it goes away. Twelve seconds without it, the
       visitor also gets a direct link to the calendar. */
    addEventListener('message', function (e) {
      if (!/^https:\/\/(app|stage|dev)\.iclosed\.io$/.test(e.origin) || !e.data || e.data.type !== 'iclosed.widget_height') return;
      var slots = root.querySelectorAll('.calslot.cal-live');
      for (var i = 0; i < slots.length; i++) slots[i].classList.add('cal-ready');
    });
    function watchBookingWidget() {
      later(function () {
        var slot = root.querySelector('.calslot.cal-live');
        var slow = slot && !slot.classList.contains('cal-ready') && slot.querySelector('.calslow');
        if (slow) slow.hidden = false;
      }, 12000);
    }
    function vattr(v) { return v.hls ? ' data-hls="' + v.hls + '"' : ''; }
    var hlsLoading = null;
    function attachHls(video) {
      var url = video.getAttribute('data-hls');
      if (!url || video.getAttribute('data-hls-on')) return;
      video.setAttribute('data-hls-on', '1');
      if (video.canPlayType('application/vnd.apple.mpegurl')) { video.src = url; video.play().catch(function () {}); return; }
      hlsLoading = hlsLoading || new Promise(function (resolve, reject) {
        if (window.Hls) return resolve(window.Hls);
        var s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.17/dist/hls.min.js';
        s.onload = function () { resolve(window.Hls); };
        s.onerror = reject;
        document.head.appendChild(s);
      });
      hlsLoading.then(function (Hls) {
        if (!Hls || !Hls.isSupported() || !video.isConnected) return;
        var h = new Hls({capLevelToPlayerSize: true});
        h.loadSource(url);
        h.attachMedia(video);
        h.on(Hls.Events.MANIFEST_PARSED, function () { video.play().catch(function () {}); });
      }).catch(function () {});
    }

    /* ---------------- question copy, from the theme blocks ----------------
       A cleared field falls back to the prototype text, so a slip in the editor
       never leaves a screen without its question. An option label cleared on
       purpose hides that option: the list cannot grow, because each option has
       its own phrasing in the copy that reads it back. */
    var Q = CFG.q || {};
    var DEF = {"pay": {"heading": "The Ultra 2 is a $2,945 investment in your well-being. How do you plan to pay for it?"}, "intro": {"heading": "Find out if the Ultra 2 chair with Posture Fit Rail System® will help you eliminate back and neck pain in just 60 days.", "sub": "Without painkillers, exercises or appointments.", "ask": "Where would you like to relieve pain?"}, "spot_other": {"heading": "Please describe where you feel discomfort.", "placeholder": "Where it hurts"}, "height": {"heading": "How tall are you?"}, "weight": {"heading": "What is your current weight?"}, "sense": {"heading": "How would you describe the sensation?"}, "sense_other": {"heading": "Please describe the sensation.", "placeholder": "How it feels"}, "dur": {"heading": "How long have you been dealing with this?"}, "intensity": {"heading": "On a typical workday, how intense is your discomfort?", "low": "Barely notice it", "high": "Unbearable"}, "name": {"heading": "What is your preferred first name?", "placeholder": "Preferred first name"}, "dream": {"heading": "What is your dream outcome if you no longer had to deal with pain and discomfort?"}, "dream_other": {"heading": "Why is it important to relieve the pain and discomfort?", "placeholder": "What it would mean for you"}, "tried": {"heading": "What have you already tried to make sitting more comfortable?", "sub": "Pick everything that applies."}, "email": {"sub": "We'll send you a copy of your results for your convenience.", "placeholder": "Email", "note": "Make sure your email is valid. Don't miss your <strong>BONUS</strong>!"}, "fit_back": {"eyebrow": "Pelvis & spine", "heading": "Let's check your back support.", "q1": "Is your lower back completely flush against the support?", "q2": "Are you slightly reclined?"}, "fit_legs": {"eyebrow": "Feet & legs", "heading": "Now your seat height and depth.", "q1": "Are your feet resting flat on the floor?", "q2": "Is there a two-to-three-finger gap between the back of your knees and the edge of the seat?", "q3": "Are your knees level with, or slightly below, your hips?"}, "diag": {"heading": "Have you ever had a diagnosed spinal condition or back surgery?", "hint": "For example a slipped disc, scoliosis or sciatica.", "yes": "Yes", "no": "No"}, "workday": {"heading": "Do you spend most of your workday seated at a fixed desk?", "yes": "Seated", "no": "Active"}};
    function tx(q, f, raw) {
      var v = Q[q] && Q[q][f];
      if (v == null || String(v).trim() === '') v = (DEF[q] && DEF[q][f]) || '';
      return raw ? String(v) : esc(v);
    }
    function applyLabels(list, blockKey, keysKey) {
      var b = Q[blockKey], map = KEYS[keysKey] || {};
      if (!b || !b.o) return;
      for (var i = list.length - 1; i >= 0; i--) {
        var label = b.o[map[list[i][0]]];
        if (label == null) continue;
        if (!String(label).trim()) list.splice(i, 1);
        else list[i][1] = String(label);
      }
    }

    var $ = function (id) { return root.querySelector('#' + id); };

    /* The store's popup (Klaviyo) and chat (Tidio) stay off this page: the CSS
       hides them, and this covers the chat API and anything injected late. */
    function quietApps() {
      try { if (window.tidioChatApi) { tidioChatApi.hide(); } } catch (e) {}
      var junk = document.querySelectorAll('#tidio-chat, [class*="kl-private-reset-css"], div.needsclick[role="dialog"]');
      for (var i = 0; i < junk.length; i++) junk[i].style.setProperty('display', 'none', 'important');
    }
    document.addEventListener('tidioChat-ready', quietApps);
    quietApps();
    if (window.MutationObserver) {
      var quietTimer = null;
      new MutationObserver(function () {
        if (!quietTimer) quietTimer = setTimeout(function () { quietTimer = null; quietApps(); }, 50);
      }).observe(document.body, {childList: true});
    }

    /* ---------------- telemetry ----------------
       Write-only and never awaited: a dead endpoint must not stall the funnel.
       Every event is also dispatched on the root as a DOM event, which is what
       the headless test harness listens to. Free text, the email and the medical
       history answer are recorded as answered, never with their content. */
    var ENDPOINT = String(CFG.endpoint || '').trim();
    var LIVE = /^https:\/\//.test(ENDPOINT) && ENDPOINT.indexOf('YOUR_') === -1;
    if (!LIVE && ENDPOINT) console.info('[duelhawk quiz] analytics endpoint is a placeholder: tracking off');
    /* Nothing is recorded from the theme editor, a theme preview or an automated
       browser: those page loads are us, not visitors. */
    var SH = window.Shopify || {};
    var OURS = !!(SH.designMode || (SH.theme && SH.theme.role && SH.theme.role !== 'main') ||
        /[?&]preview_theme_id=/.test(location.search) || /shopifypreview\.com$/.test(location.hostname) ||
        navigator.webdriver);
    if (LIVE && OURS) {
      LIVE = false;
      console.info('[duelhawk quiz] editor, preview or automated browser: tracking off');
    }
    /* Our own team: open the quiz once with ?dhq_internal=1 and this browser is
       recorded under the variant "internal", apart from real traffic, until it
       is opened with ?dhq_internal=0. */
    var INTERNAL = false;
    try {
      var flag = (location.search.match(/[?&]dhq_internal=([01])/) || [])[1];
      if (flag === '1') localStorage.setItem('dhq_internal', '1');
      if (flag === '0') localStorage.removeItem('dhq_internal');
      INTERNAL = localStorage.getItem('dhq_internal') === '1';
    } catch (e) {}
    if (INTERNAL) console.info('[duelhawk quiz] internal browser: recorded as variant "internal"');

    /* ---------------- Klaviyo ----------------
       Off unless "Send quiz events to Klaviyo" is ticked in the section, and never
       from the editor, a preview or an automated browser. The store's Klaviyo app
       embed loads klaviyo.js; a call made before it arrives waits in Klaviyo's
       own _klOnsite queue. Our browsers (?dhq_internal=1) do send, flagged
       quiz_internal, so the flows can leave them out.
       Nothing here subscribes anyone to a list: identify only links this browser
       to the email, which is what lets the events reach the right profile. */
    var KLAVIYO = CFG.klaviyo === true && !OURS;
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    function klaviyoCall(method, args) {
      if (!KLAVIYO) return Promise.resolve();
      root.dispatchEvent(new CustomEvent('dhq:klaviyo', {detail: {method: method, args: args}, bubbles: true}));
      try {
        var k = window.klaviyo;
        if (k && typeof k[method] === 'function') return Promise.resolve(k[method].apply(k, args)).catch(function () {});
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push([method].concat(args));
      } catch (e) {}
      return Promise.resolve();
    }
    function klaviyoIdentify() {
      var email = String(ans.email || '').trim();
      if (!EMAIL_RE.test(email)) return;
      var who = {email: email};
      var first = String(ans.name || '').trim();
      if (first) who.first_name = first.slice(0, 60);
      klaviyoCall('identify', [who]);
    }
    /* Event properties use the same stable keys as the analytics, plus two short
       readable labels for email copy. Free text, the email and the medical history
       answer never go. */
    var KLAVIYO_PROPS = {spot: 'pain_area', sense: 'sensation', dur: 'duration', intensity: 'discomfort',
                         dream: 'goal', tried: 'tried', height: 'height_band', weight: 'weight_band', workday: 'workday', pay: 'payment_plan'};
    function klaviyoProps() {
      var p = {quiz_key: CFG.quizKey, quiz_internal: INTERNAL,
               booking_url: location.origin + location.pathname + '?step=reserved'};
      Object.keys(KLAVIYO_PROPS).forEach(function (k) {
        var v = ans[k];
        if (v == null || v === '' || (Array.isArray(v) && !v.length)) return;
        var keys = optionKeys(k, v);
        p[KLAVIYO_PROPS[k]] = k === 'tried' ? keys : (k === 'intensity' ? Number(v) : keys[0]);
      });
      if (ans.spot && ans.spot !== 'g') p.pain_area_label = spotIn();
      if (ans.dream && ans.dream !== 'f') p.goal_label = dreamIn();
      if (fitAnswered()) p.setup_checks_failed = misfits();
      return p;
    }
    var quizCompletedSent = false;

    /* For Google Tag Manager, once, when the quiz is completed. The tags that send
       these to Meta live in the container. Internal browsers stay out of it. */
    function pushLeadOutcome() {
      if (!LIVE || INTERNAL || !ans.pay) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: ans.pay === 'c' ? 'dhq_disqualified_lead' : 'dhq_qualified_lead',
        dhq_payment_plan: optionKeys('pay', ans.pay)[0]
      });
    }

    var UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    function uuid() {
      try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
      var b = new Uint8Array(16);
      if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(b);
      else for (var i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256);
      b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
      var h = Array.prototype.map.call(b, function (x) { return (x + 256).toString(16).slice(1); }).join('');
      return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
    }
    var SESSION = (function () {
      try {
        var v = sessionStorage.getItem('dhq_session');
        if (!v || !UUID_RE.test(v)) { v = uuid(); sessionStorage.setItem('dhq_session', v); }
        return v;
      } catch (e) { return uuid(); }
    })();

    var queue = [], flushTimer = null, leaving = false;
    function track(type, data) {
      var ev = {event_id: uuid(), session_id: SESSION, quiz_key: CFG.quizKey, variant: INTERNAL ? 'internal' : (CFG.variant || 'main'), type: type};
      for (var k in data) if (data[k] !== undefined && data[k] !== null) ev[k] = data[k];
      root.dispatchEvent(new CustomEvent('dhq:event', {detail: ev, bubbles: true}));
      if (!LIVE) return;
      queue.push(ev);
      if (queue.length >= 25) flush(false);
      else if (!flushTimer) flushTimer = setTimeout(function () { flush(false); }, 900);
    }
    function flush(unloading) {
      if (flushTimer) { clearTimeout(flushTimer); flushTimer = null; }
      if (!LIVE || !queue.length) return;
      var body = JSON.stringify({events: queue.splice(0, 50)});
      try {
        if (unloading && navigator.sendBeacon) {
          /* sendBeacon cannot set headers, so the key rides on the query string. A
             JSON beacon carries credentials and fails the endpoint's preflight, which
             lost every click and exit event; text/plain goes without a preflight. */
          var url = CFG.eventsKey ? ENDPOINT + (ENDPOINT.indexOf('?') === -1 ? '?' : '&') + 'apikey=' + encodeURIComponent(CFG.eventsKey) : ENDPOINT;
          navigator.sendBeacon(url, new Blob([body], {type: 'text/plain'}));
        } else {
          var headers = {'Content-Type': 'application/json'};
          if (CFG.eventsKey) { headers.apikey = CFG.eventsKey; headers.Authorization = 'Bearer ' + CFG.eventsKey; }
          fetch(ENDPOINT, {method: 'POST', keepalive: true, headers: headers, body: body}).catch(function () {});
        }
      } catch (e) {}
      if (queue.length) flush(unloading);
    }

    /* Stable keys for the reports. Letters in the prototype are positions. */
    var KEYS = {"pay": {"a": "cash", "b": "financing", "c": "not-sure"}, "spot": {"a": "lower-back", "b": "mid-back", "c": "upper-back", "d": "neck-shoulders", "e": "hips-pelvis", "f": "legs", "g": "other"}, "sense": {"a": "dull-ache", "b": "sharp-stabbing", "c": "burning", "d": "tightness-stiffness", "e": "numbness-tingling", "f": "other"}, "dur": {"a": "few-weeks", "b": "1-6-months", "c": "years", "d": "lost-track"}, "dream": {"a": "enjoy-life", "b": "more-activities", "c": "exercise-health", "d": "productivity", "e": "friends-family", "f": "other"}, "tried": {"a": "cushions", "b": "stretching", "c": "painkillers", "d": "physio-chiro", "e": "standing-desk", "f": "desk-monitor-height"}};
    var SCREEN_Q = {"pay": ["pay"], "intro": ["spot"], "spot_other": ["spot_other"], "height": ["height"], "weight": ["weight"], "sense": ["sense"], "sense_other": ["sense_other"], "dur": ["dur"], "intensity": ["intensity"], "name": ["name"], "dream": ["dream"], "dream_other": ["dream_other"], "tried": ["tried"], "email": ["email"], "fit_back": ["flush", "recline"], "fit_legs": ["feet", "gap", "knees"]};
    /* Recorded as answered, never with the content. The email is the exception
       the client asked for (Oct 2026): the team needs to know who answered what. */
    var PRIVATE = {spot_other: 1, sense_other: 1, dream_other: 1, name: 1, diag: 1};
    function optionKeys(k, v) {
      /* Height and weight go as bands, never the exact figure. */
      if (k === 'height') { var h = Math.round(v), lo = h - h % 2; return [lo + '-' + (lo + 1) + 'in']; }
      if (k === 'weight') { var w = Math.round(v), lw = w - w % 20; return [lw + '-' + (lw + 19) + 'lb']; }
      if (k === 'intensity') return [String(v)];
      if (k === 'email') {
        /* The endpoint keeps answers up to 64 characters; a longer or malformed
           address goes as answered, without the content. */
        var e = String(v).trim().toLowerCase();
        return EMAIL_RE.test(e) && e.length <= 64 ? [e] : null;
      }
      var map = KEYS[k] || {};
      if (Array.isArray(v)) return v.map(function (x) { return map[x] || String(x); });
      if (v === 'y') return ['yes'];
      if (v === 'n') return ['no'];
      return [map[v] || String(v)];
    }
    function commitKey(screen, k) {
      var v = ans[k];
      if (v == null || (Array.isArray(v) && !v.length) || (typeof v === 'string' && !v.trim())) return;
      var data = {screen_key: screen, question_key: k};
      if (!PRIVATE[k]) { var keys = optionKeys(k, v); if (keys) data.option_keys = keys; }
      track('answer', data);
      if (k === 'email') klaviyoIdentify();
    }
    function commit(screen) { (SCREEN_Q[screen] || []).forEach(function (k) { commitKey(screen, k); }); }

    /* Fires once per screen transition, from render(). go() is the only thing that
       moves `cur`, but render() also runs on every toggle, so it dedupes by id.
       ms_on_screen on a view event is the time spent on the screen before it. */
    var TYPE_OF = {load1: 'loader_view', load2: 'loader_view', result1: 'result_view', reveal: 'result_view',
                   predict: 'result_view', offer: 'result_view', reserved: 'result_view'};
    var lastScreen = null, started = false, screenAt = Date.now();
    function emit(id) {
      if (id === lastScreen) return;
      if (lastScreen !== null && !started) { started = true; track('quiz_start', {}); }
      var prev = lastScreen;
      lastScreen = id;
      track(TYPE_OF[id] || 'screen_view', {
        screen_key: id, screen_index: cur,
        ms_on_screen: prev === null ? undefined : Date.now() - screenAt
      });
      screenAt = Date.now();
      if (id === 'offer') saveState();
      if (id === 'offer' && !quizCompletedSent) {
        quizCompletedSent = true;
        klaviyoCall('track', ['Duelhawk Quiz Completed', klaviyoProps()]);
        pushLeadOutcome();
      }
      if (id === 'reserved') { loadBookingWidget(); watchBookingWidget(); }
    }

    /* The reserved screen comes after payment, which happens off this page. The
       answers wait in this browser so /pages/<quiz>?step=reserved can pick up where
       the visitor left. The email is not kept. */
    var STATE_KEY = 'dhq_state_' + (CFG.quizKey || 'quiz');
    function saveState() {
      try {
        var keep = {};
        for (var k in ans) if (k !== 'email') keep[k] = ans[k];
        localStorage.setItem(STATE_KEY, JSON.stringify({v: 1, at: Date.now(), ans: keep}));
      } catch (e) {}
    }
    function restoreState() {
      try {
        var s = JSON.parse(localStorage.getItem(STATE_KEY) || 'null');
        if (!s || s.v !== 1 || Date.now() - s.at > 30 * 864e5) return false;
        Object.keys(s.ans || {}).forEach(function (k) { ans[k] = s.ans[k]; });
        return true;
      } catch (e) { return false; }
    }

    addEventListener('pagehide', function () {
      var id = flow()[cur];
      if (!leaving && id && id !== 'reserved') {
        track('abandon', {screen_key: id, screen_index: cur, ms_on_screen: Date.now() - screenAt});
      }
      flush(true);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flush(true);
    });

    DHQ.checkout = function () {
      track('cta_click', {screen_key: 'offer', screen_index: cur});
      saveState();
      var sent = klaviyoCall('track', ['Duelhawk Quiz Checkout Started', klaviyoProps()]);
      if (!CFG.offerUrl) {
        /* No payment link yet: the flow carries on to the reserved screen so the
           whole quiz can be reviewed. Setting the link is a go-live requirement. */
        console.warn('[duelhawk quiz] no payment link set: going straight to the reserved screen');
        next();
        return;
      }
      leaving = true;
      flush(true);
      /* Shopify answers 422 to a cart link whose email it rejects (test.com, or a
         mistyped domain such as gmial.con), and the visitor lands on an error page
         with no way to pay. A HEAD request checks the link first: a rejection, or no
         answer within 1.5 s, sends the visitor to checkout without the email.
         Leaving the page right away could also cut the Klaviyo request short, so it
         gets up to 800 ms; the checkout matters more than the event. */
      var target = checkoutUrl(CFG.offerUrl), plain = checkoutUrl(CFG.offerUrl, true), gone = false;
      var leave = function (url) { if (!gone) { gone = true; DHQ._navigate(url); } };
      var checked = target === plain ? Promise.resolve(target) :
        fetch(target, {method: 'HEAD', redirect: 'manual', credentials: 'same-origin'})
          .then(function (r) { return r.status === 422 ? plain : target; }, function () { return plain; });
      var tracked = KLAVIYO ? Promise.race([sent, new Promise(function (r) { setTimeout(r, 800); })]) : Promise.resolve();
      Promise.all([checked, tracked]).then(function (v) { leave(v[0]); }, function () { leave(plain); });
      setTimeout(function () { leave(plain); }, 1500);
    };
    DHQ._navigate = function (url) { location.href = url; };
    /* A cart permalink (/cart/VARIANT:1) takes the email straight into checkout
       and carries the main answers into the order notes, where the team that
       follows up on the $199 reservation reads them. Shopify documents
       checkout[email], attributes[...] and ref on cart permalinks. */
    function checkoutUrl(base, withoutEmail) {
      if (!/\/cart\/\d+:\d+/.test(base)) return base;
      var q = [], add = function (k, v) { if (v) q.push(encodeURIComponent(k) + '=' + encodeURIComponent(String(v).slice(0, 200))); };
      var email = String(ans.email || '').trim();
      if (!withoutEmail && EMAIL_RE.test(email)) add('checkout[email]', email);
      add('attributes[Quiz: name]', (ans.name || '').trim());
      add('attributes[Quiz: pain area]', ans.spot === 'g' ? (ans.spot_other || 'other') : spotIn());
      add('attributes[Quiz: sensation]', ans.sense === 'f' ? (ans.sense_other || 'other') : senseIn());
      var dur = pick(DUR, ans.dur); add('attributes[Quiz: how long]', dur && dur[1]);
      add('attributes[Quiz: discomfort]', ans.intensity ? ans.intensity + '/10' : '');
      add('attributes[Quiz: goal]', ans.dream === 'f' ? (ans.dream_other || 'other') : dreamIn());
      add('attributes[Quiz: tried]', (ans.tried || []).map(function (k) { var o = pick(TRIED, k); return o && o[1]; }).filter(Boolean).join('; '));
      add('attributes[Quiz: height]', ans.height ? fmtHeight(ans.height).replace(/<[^>]+>/g, '') : '');
      add('attributes[Quiz: weight]', ans.weight ? fmtWeight(ans.weight).replace(/<[^>]+>/g, '') : '');
      add('attributes[Quiz: setup checks failed]', fitAnswered() ? misfits() + ' of 5' : '');
      add('attributes[Quiz: workday]', ans.workday);
      add('attributes[Quiz: payment plan]', ans.pay ? optionKeys('pay', ans.pay)[0] : '');
      add('ref', CFG.quizKey);
      return base + (base.indexOf('?') === -1 ? '?' : '&') + q.join('&');
    }
    DHQ.book = function () {
      track('cta_click', {screen_key: 'reserved', screen_index: cur});
      var cal = root.querySelector('.calslot.cal-live');
      if (cal) { flush(false); cal.scrollIntoView({behavior: 'smooth', block: 'start'}); return; }
      if (CFG.bookingUrl) { leaving = true; flush(true); location.href = CFG.bookingUrl; }
    };

    /* ---------- icons ---------- */
    const I = {
      back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>',
      check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>',
      check2: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>',
      star: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z"/></svg>',
      people: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
      shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>'
    };

    /* ---------- answer options ---------- */
    /* label is what the button shows, inline is how the answer reads inside a sentence */
    /* fourth slot is the zone illustration key on ILL, fifth is its vertical framing */
    const SPOT = [
      ['a', 'Lower back', 'lower back', 'z_lower', 36],
      ['b', 'Mid-back', 'mid-back', 'z_mid', 10],
      ['c', 'Upper back / between shoulder blades', 'upper back', 'z_upper', 0],
      ['d', 'Neck / shoulders', 'neck and shoulders', 'z_neck', 0],
      ['e', 'Hips / pelvis', 'hips and pelvis', 'z_hips', 58],
      ['f', 'Legs', 'legs', 'z_legs', 100],
      ['g', 'Other', 'discomfort', 'z_other', null]
    ];
    const SENSE = [
      ['a', 'Dull ache', 'dull ache'],
      ['b', 'Sharp / stabbing', 'sharp, stabbing pain'],
      ['c', 'Burning', 'burning'],
      ['d', 'Tightness / stiffness', 'tightness and stiffness'],
      ['e', 'Numbness / tingling', 'numbness and tingling'],
      ['f', 'Other', 'pain']
    ];
    const DUR = [
      ['a', 'A few weeks', 'a few weeks'],
      ['b', '1 to 6 months', 'months'],
      ['c', 'Years', 'years'],
      ['d', "I've lost track", 'as long as you can remember']
    ];
    const DREAM = [
      ['a', 'Go back to enjoying life', 'get back to enjoying life', 'enjoying life'],
      ['b', 'Do more activities', 'do more of the activities you miss', 'doing more activities'],
      ['c', 'Exercise more / better health', 'exercise more', 'exercising more'],
      ['d', 'Be more productive / work more', 'work without the distraction', 'being more productive'],
      ['e', 'Spend time with friends & family', 'spend real time with the people you care about', 'spending time with friends and family'],
      ['f', 'Other', 'get back to what matters', 'what matters to you']
    ];
    /* thumbnails reused from the v1 asset set, matched to this brief's six options */
    /* The fourth slot is the thumbnail key. Those keys were drawn for the v1 option
       list, which ran in a different order, so each one is matched by subject here. */
    const TRIED = [
      ['a', 'Adding cushions or a lumbar pillow', 'cushions', 'b'],
      ['b', 'Stretching exercises', 'stretching', 'g'],
      ['c', 'Pain killers or muscle relaxants', 'painkillers', 'f'],
      ['d', 'Physical therapy and chiropractor visits', 'physio and chiropractic', 'e'],
      ['e', 'A standing desk or sit-stand setup', 'a standing desk', 'd'],
      ['f', 'Changing desk or monitor height', 'moving the desk around', 'c']
    ];

    const PAY = [
      ['a', 'Pay with cash in full'],
      ['b', 'Monthly payment plan or financing'],
      ['c', 'Not sure yet / need to save up']
    ];

    /* option labels edited in the theme editor */
    applyLabels(PAY, 'pay', 'pay');
    applyLabels(SPOT, 'intro', 'spot'); applyLabels(SENSE, 'sense', 'sense'); applyLabels(DUR, 'dur', 'dur'); applyLabels(DREAM, 'dream', 'dream'); applyLabels(TRIED, 'tried', 'tried');

    /* ---------- state ---------- */
    let ans = {};
    let cur = 0;
    let MODE = 'all';
    let beat = 0;          /* which card of a rolling sequence is showing */
    let timers = [];       /* every pending timeout, cleared on each render */

    const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const pick = (list, k) => list.find(o => o[0] === k);
    const later = (fn, ms) => { timers.push(setTimeout(fn, ms)); };
    const clearTimers = () => { timers.forEach(clearTimeout); timers = []; };

    /* ---------- derived copy ---------- */
    function name() { return (ans.name || '').trim() || 'there'; }
    function spotIn() { const o = pick(SPOT, ans.spot); return o ? o[2] : 'back'; }
    /* The area as an adjective: "lower back " for a named zone, nothing for Other. */
    function spotPre() { return ans.spot && ans.spot !== 'g' ? spotIn() + ' ' : ''; }
    function spotCaps() { const s = spotIn(); return s.charAt(0).toUpperCase() + s.slice(1); }
    function senseIn() { const o = pick(SENSE, ans.sense); return o ? o[2] : 'pain'; }
    /* Fourth slot is the goal as it reads after "getting back to". */
    function dreamIng() { const o = pick(DREAM, ans.dream); return o ? o[3] : 'what matters to you'; }
    function dreamIn() { const o = pick(DREAM, ans.dream); return o ? o[2] : 'get back to what matters'; }

    /* The brief's sentence is "...temporary relief like [Answer from Q] painkillers,
       exercises or chiropractic adjustments": the slot takes what they ticked, phrased
       the way the brief phrases its own example, and falls back to that example. */
    const TRIED_WORD = {a: 'cushions', b: 'exercises', c: 'painkillers', d: 'chiropractic adjustments', e: 'standing desks', f: 'desk adjustments'};
    function triedIn() {
      const got = ['c', 'b', 'd', 'a', 'e', 'f'].filter(k => (ans.tried || []).includes(k)).map(k => TRIED_WORD[k]).slice(0, 3);
      if (!got.length) return 'painkillers, exercises or chiropractic adjustments';
      if (got.length === 1) return got[0];
      return got.slice(0, -1).join(', ') + ' or ' + got[got.length - 1];
    }

    /* Three months out, written the way the brief writes it: "12 January". */
    function targetDate() {
      const d = new Date();
      d.setMonth(d.getMonth() + 3);
      return d.getDate() + ' ' + d.toLocaleString('en-GB', { month: 'long' });
    }
    /* Three calendar days out, as the client's mockup writes it: "5th Nov". */
    function deliveryDate() {
      const d = new Date();
      d.setDate(d.getDate() + 3);
      const n = d.getDate();
      const suf = (n % 100 >= 11 && n % 100 <= 13) ? 'th' : (['th', 'st', 'nd', 'rd'][n % 10] || 'th');
      return n + suf + ' ' + d.toLocaleString('en-GB', { month: 'short' });
    }

    function intensity() { return ans.intensity || 7; }

    /* How far their current setup sits from a supported one. Five yes/no checks across
       the two posture screens; every "No" is one thing the chair is not doing for them. */
    function misfits() {
      const keys = ['flush', 'recline', 'feet', 'gap', 'knees'];
      return keys.filter(k => ans[k] === 'n').length;
    }
    function fitAnswered() {
      return ['flush', 'recline', 'feet', 'gap', 'knees'].filter(k => ans[k]).length;
    }

    /* ---------- flow ---------- */
    /* Conditional screens only enter the flow once their trigger is answered. */
    const COND = {
      spot_other: () => ans.spot === 'g',
      sense_other: () => ans.sense === 'f',
      dream_other: () => ans.dream === 'f'
    };

    const ORDER = [
      'intro', 'spot_other',
      'height', 'weight',
      'sense', 'sense_other',
      'dur', 'intensity', 'name',
      'e_trust',
      'dream', 'dream_other',
      'tried',
      'e_habit', 'e_testi',
      'load1', 'email',
      'result1', 'e_goals',
      'fit_back', 'e_back',
      'fit_legs', 'e_legs', 'e_adapt',
      'why', 'pay', 'thanks',
      'load2',
      'reveal', 'predict', 'offer', 'reserved'
    ];
    /* "Result only" preview: everything from the prediction onward. */
    const RES = ['result1', 'reveal', 'predict', 'offer', 'reserved'];

    const vis = k => (COND[k] ? COND[k]() : true);
    const flow = () => (MODE === 'res' ? RES : ORDER.filter(vis));

    /* ---------- navigation ---------- */
    function go(i) {
      const f = flow();
      if (i > cur) commit(f[cur]);
      cur = Math.max(0, Math.min(f.length - 1, i));
      beat = 0;
      render();
    }
    function next() { go(cur + 1); }
    function back() { go(cur - 1); }

    /* Single-select answers advance on their own, the way the reference funnels do. */
    function setOne(k, v) {
      ans[k] = v;
      render();
      later(() => { if (flow()[cur] === currentId) next(); }, 190);
    }
    let currentId = '';

    function toggleMulti(k, v) {
      const a = (ans[k] || []).slice();
      const i = a.indexOf(v);
      if (i >= 0) a.splice(i, 1); else a.push(v);
      ans[k] = a;
      render();
    }
    /* Yes/no checks update in place: a re-render would throw the screen back to the
       top, and a third check sitting below the fold would never be seen. After each
       answer the next unanswered check scrolls into view. */
    function setYN(k, v) {
      ans[k] = v;
      const block = $('scr').querySelector(`.yn[data-k="${k}"]`);
      if (!block) { render(); return; }
      block.querySelectorAll('.ynb').forEach(b => b.setAttribute('aria-pressed', b.dataset.v === v ? 'true' : 'false'));
      refreshCta();
      showPending();
    }
    /* The next yes/no check with no answer, brought into view. */
    function showPending() {
      const open = [...$('scr').querySelectorAll('.yn')].find(b => !ans[b.dataset.k]);
      if (open) open.scrollIntoView({behavior: 'smooth', block: 'center'});
      return !!open;
    }
    /* A tap on the footer while Continue is still disabled goes to what is missing.
       The disabled button lets the tap through to the footer (pointer-events:none). */
    function ftrTap(e) {
      const btn = $('cta');
      if (!btn || !btn.disabled || e.target === btn) return;
      if (showPending()) return;
      const empty = $('scr').querySelector('.tin');
      if (empty) empty.focus();
    }
    function setText(k, v) { ans[k] = v; refreshCta(); }

    /* Slider handlers update the DOM in place. A re-render mid-drag drops the thumb. */
    function slide(el, k, fmt) {
      const v = +el.value;
      ans[k] = v;
      const min = +el.min, max = +el.max;
      el.style.setProperty('--p', ((v - min) / (max - min) * 100) + '%');
      const rate = el.closest('.rate');
      if (rate) {
        rate.dataset.set = '1';
        const out = rate.querySelector('.bignum');
        if (out) out.innerHTML = fmt ? DHQ[fmt](v) : v;
      }
      refreshCta();
    }
    function fmtTen(v) {
      return v + '<span style="font-size:20px;color:var(--mute)"> / 10</span>';
    }
    /* Height is kept in inches and weight in pounds, as decimals, so switching units
       and back never drifts. Each unit slides in its own whole steps: 1 cm, 1 in,
       1 kg, 1 lb. */
    const H_RANGE = {imp: [57, 81], met: [145, 206]};
    const W_RANGE = {imp: [90, 400], met: [41, 181]};
    const hShown = v => ans.hUnit === 'met' ? Math.round(v * 2.54) : Math.round(v);
    const wShown = v => ans.wUnit === 'met' ? Math.round(v * 0.4536) : Math.round(v);
    function fmtHeight(v) {
      if (ans.hUnit === 'met') return Math.round(v * 2.54) + ' <span style="font-size:20px">cm</span>';
      const t = Math.round(v);
      return Math.floor(t / 12) + "'" + (t % 12) + '"';
    }
    function fmtWeight(v) {
      if (ans.wUnit === 'met') return Math.round(v * 0.4536) + ' <span style="font-size:20px">kg</span>';
      return Math.round(v) + ' <span style="font-size:20px">lb</span>';
    }
    const pct = (v, r) => Math.max(0, Math.min(100, (v - r[0]) / (r[1] - r[0]) * 100));

    /* The number above the slider is itself a field: tap it and type. Slider and
       field write to the same answer and update each other in place, never through a
       re-render, so the keyboard and the thumb both keep their place. */
    function hFields(v) {
      if (ans.hUnit === 'met') {
        return `<input class="numin w3" id="hcm" type="number" inputmode="numeric" value="${hShown(v)}" aria-label="Height in centimetres"
          oninput="DHQ.hTyped()" onblur="DHQ.hSync()"><span class="numu">cm</span>`;
      }
      const t = Math.round(v);
      return `<input class="numin w1" id="hft" type="number" inputmode="numeric" value="${Math.floor(t / 12)}" aria-label="Feet"
          oninput="DHQ.hTyped()" onblur="DHQ.hSync()"><span class="numu q">'</span><input class="numin w2" id="hin" type="number" inputmode="numeric" value="${t % 12}" aria-label="Inches"
          oninput="DHQ.hTyped()" onblur="DHQ.hSync()"><span class="numu q">"</span>`;
    }
    /* Each field is as wide as the digits in it, so 5'8" reads as one figure. */
    function fitNum(el) {
      if (!el) return;
      /* Measure with a hidden span carrying the field's own computed font: a canvas
         measurement can resolve to a different face and clip the digits. */
      let m = $('numMeasure');
      if (!m) { m = document.createElement('span'); m.id = 'numMeasure';
        m.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;left:-9999px;top:0'; root.appendChild(m); }
      const cs = getComputedStyle(el);
      ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'fontVariantNumeric', 'fontFeatureSettings', 'letterSpacing'].forEach(k => { m.style[k] = cs[k]; });
      m.textContent = String(el.value || '0');
      el.style.width = Math.ceil(m.getBoundingClientRect().width + 3) + 'px';
    }
    function fitAll() { $('scr').querySelectorAll('.numin').forEach(fitNum); }
    function hSlide(el) {
      const u = ans.hUnit === 'met' ? 'met' : 'imp', val = +el.value;
      ans.height = u === 'met' ? val / 2.54 : val;
      el.style.setProperty('--p', pct(val, H_RANGE[u]) + '%');
      hSync(true);
      refreshCta();
    }
    function hTyped() {
      let inches;
      if (ans.hUnit === 'met') { const c = +($('hcm').value); if (!c) return; inches = c / 2.54; }
      else { const f = +($('hft').value), i = +($('hin').value || 0); if (!f) return; inches = f * 12 + i; }
      const r = H_RANGE.imp;
      if (inches < r[0] - 0.5 || inches > r[1] + 0.5) return;   /* half-typed: wait for the rest */
      ans.height = inches;
      const sl = $('scr').querySelector('.slider');
      if (sl) { const u = ans.hUnit === 'met' ? 'met' : 'imp'; sl.value = hShown(inches); sl.style.setProperty('--p', pct(hShown(inches), H_RANGE[u]) + '%'); }
      fitAll();
      refreshCta();
    }
    /* Writes the stored answer back into the field(s): after a drag, or on leaving a
       field that holds something out of range. */
    function hSync(fromSlider) {
      const v = ans.height;
      if (ans.hUnit === 'met') { const e = $('hcm'); if (e) e.value = hShown(v); }
      else { const t = Math.round(v), f = $('hft'), i = $('hin'); if (f) f.value = Math.floor(t / 12); if (i) i.value = t % 12; }
      if (!fromSlider) { const sl = $('scr').querySelector('.slider'); if (sl) sl.value = hShown(v); }
      fitAll();
    }
    function wFields(v) {
      return `<input class="numin w3" id="wv" type="number" inputmode="numeric" value="${wShown(v)}" aria-label="Weight"
          oninput="DHQ.wTyped()" onblur="DHQ.wSync()"><span class="numu">${ans.wUnit === 'met' ? 'kg' : 'lb'}</span>`;
    }
    function wSlide(el) {
      const u = ans.wUnit === 'met' ? 'met' : 'imp', val = +el.value;
      ans.weight = u === 'met' ? val / 0.4536 : val;
      el.style.setProperty('--p', pct(val, W_RANGE[u]) + '%');
      wSync(true);
      refreshCta();
    }
    function wTyped() {
      const n = +($('wv').value); if (!n) return;
      const u = ans.wUnit === 'met' ? 'met' : 'imp', r = W_RANGE[u];
      if (n < r[0] || n > r[1]) return;
      ans.weight = u === 'met' ? n / 0.4536 : n;
      const sl = $('scr').querySelector('.slider');
      if (sl) { sl.value = n; sl.style.setProperty('--p', pct(n, r) + '%'); }
      fitAll();
      refreshCta();
    }
    function wSync(fromSlider) {
      const e = $('wv'); if (e) e.value = wShown(ans.weight);
      if (!fromSlider) { const sl = $('scr').querySelector('.slider'); if (sl) sl.value = wShown(ans.weight); }
      fitAll();
    }
    function setUnit(k, v) { ans[k] = v; render(); }

    /* ---------- charts ---------- */
    /* Palette from workflows/brand_configs/duelhawk.json -> colors_light_surface.
       The pair was validated on a white surface: CVD deltaE 12.0, normal-vision 23.4,
       both marks over 3:1 contrast. Two series, so a legend is always present and
       both lines are direct-labelled: identity never rests on colour alone. */
    const S1 = '#17907F', S2 = '#C45A28', GRID = '#E6E9EC';

    /* Chart look follows the client's Figma: soft card, bold title, L-shaped axis,
       a pale fill under the supported line and a hollow ring on the point being read.
       The numbers stay live, driven by the person's own 1 to 10 rating. */
    const AXIS = '#AAB2B8', FILL = '#DFF6F1';

    /* Discomfort over six months: what temporary relief does against daily support. */
    function chartHabit() {
      const W = 300, H = 118, L = 5, T = 20, B = 6;
      const start = intensity();
      const top = start + 0.9;
      const clamp = v => Math.max(0.5, Math.min(10, v));
      const x = i => L + (i / 6) * (W - L) * 0.955;
      const y = v => T + (1 - clamp(v) / top) * (H - T - B);
      /* Temporary relief dips then returns: each attempt buys a few weeks. */
      const relief = [start, start - 1.3, start - 0.9, start - 1.9, start - 1.2, start - 2.3, start - 0.5];
      /* Daily support compounds instead of resetting. */
      const dh = [start, start - 1.3, start - 2.6, start - 3.8, start - 4.7, start - 5.5, start - 5.9];
      const path = a => a.map((v, i) => (i ? 'L' : 'M') + x(i).toFixed(1) + ' ' + y(v).toFixed(1)).join(' ');
      const area = path(dh) + ` L${x(6).toFixed(1)} ${H - B} L${x(0)} ${H - B} Z`;
      return `<div class="chart">
        <p class="chartt ctr">Your discomfort over 6 months</p>
        <svg viewBox="0 0 ${W} ${H}" role="img" aria-label="Discomfort over six months. Temporary relief drops and returns to ${clamp(relief[6]).toFixed(1)} out of 10. Daily support falls steadily to ${clamp(dh[5]).toFixed(1)} out of 10.">
          <path d="${area}" fill="${FILL}"/>
          <path d="M${L} ${T - 12} V${H - B} H${W}" fill="none" stroke="${AXIS}" stroke-width="1"/>
          <path d="${path(relief)}" fill="none" stroke="${S2}" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"/>
          <path d="${path(dh)}" fill="none" stroke="${S1}" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"/>
          <circle cx="${x(0)}" cy="${y(start)}" r="3.6" fill="${S1}"/>
          <circle cx="${x(6)}" cy="${y(relief[6])}" r="3.8" fill="${S2}"/>
          <circle cx="${x(5)}" cy="${y(dh[5])}" r="5" fill="#fff" stroke="${S1}" stroke-width="2"/>
          <text class="ctxtb" x="${x(6) + 3}" y="${y(relief[6]) - 9}" text-anchor="end">${clamp(relief[6]).toFixed(1)}/10</text>
          <text class="ctxtb" x="${x(5) + 4}" y="${y(dh[5]) - 10}" text-anchor="middle">${clamp(dh[5]).toFixed(1)}/10</text>
        </svg>
        <div class="cax"><span>Month 1</span><span>Month 6</span></div>
        <div class="legend">
          <span><i style="background:${S1}"></i>Daily support</span>
          <span><i style="background:${S2}"></i>Temporary relief</span>
        </div>
      </div>`;
    }

    /* Two bars, the brief's "twice as likely" comparison. Drawn exactly 1 to 2. */
    function chartTwice() {
      const W = 300, H = 128, base = 104, bw = 68;
      const h2 = 84, h1 = h2 / 2, x1 = 48, x2 = 184;
      return `<div class="chart">
        <p class="chartt">Reaching your goal</p>
        <svg viewBox="0 0 ${W} ${H}" role="img" aria-label="People using Ultra 2 are about twice as likely to reach their goal as people trying on their own.">
          <defs>
            <linearGradient id="gOwn" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#E2AF98"/><stop offset="1" stop-color="#F3DACE"/></linearGradient>
            <linearGradient id="gU2" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#0C6156"/><stop offset="1" stop-color="#17907F"/></linearGradient>
          </defs>
          <path d="M${x1} ${base} v${-h1 + 3} q0 -3 3 -3 h${bw - 6} q3 0 3 3 v${h1 - 3} z" fill="url(#gOwn)"/>
          <path d="M${x2} ${base} v${-h2 + 3} q0 -3 3 -3 h${bw - 6} q3 0 3 3 v${h2 - 3} z" fill="url(#gU2)"/>
          <line x1="2" y1="${base}" x2="${W - 2}" y2="${base}" stroke="${AXIS}" stroke-width="1"/>
          <text class="ctxtg" x="${x1 + bw / 2}" y="${base - h1 - 8}" text-anchor="middle">1x</text>
          <text class="ctxtg" x="${x2 + bw / 2}" y="${base - h2 - 8}" text-anchor="middle">2x</text>
          <text class="ctxtg" x="${x1 + bw / 2}" y="${base + 18}" text-anchor="middle">On your own</text>
          <text class="ctxtb" x="${x2 + bw / 2}" y="${base + 18}" text-anchor="middle">With Ultra 2</text>
        </svg>
      </div>`;
    }

    /* The prediction line: today's level falling to the projected level by the target
       date, with the trend carried a little past the target ring. */
    function chartPredict() {
      const W = 300, H = 112, L = 24, T = 14, B = 6;
      const start = intensity();
      const end = Math.max(0.8, start * 0.29);
      const top = start + 2.2;
      const xs = [0, 0.3, 0.6, 0.86, 1];
      const vs = [start, start - (start - end) * 0.26, start - (start - end) * 0.66, end, Math.max(0.3, end - (start - end) * 0.09)];
      const x = f => L + f * (W - L);
      const y = v => T + (1 - v / top) * (H - T - B);
      const d = vs.map((v, i) => (i ? 'L' : 'M') + x(xs[i]).toFixed(1) + ' ' + y(v).toFixed(1)).join(' ');
      const mo = [];
      for (let i = 0; i < 4; i++) { const t = new Date(); t.setMonth(t.getMonth() + i); mo.push(t.toLocaleString('en-GB', { month: 'short' })); }
      return `<div class="chart">
        <p class="chartt">Projected discomfort</p>
        <svg viewBox="0 0 ${W} ${H}" role="img" aria-label="Projected discomfort falling from ${start} out of 10 today to about ${end.toFixed(1)} out of 10 by ${targetDate()}.">
          <path d="${d} L${W} ${H - B} L${L} ${H - B} Z" fill="${FILL}"/>
          <path d="M${L} ${T - 10} V${H - B} H${W}" fill="none" stroke="${AXIS}" stroke-width="1"/>
          <path d="M${L} ${y(start)} h6 M${L} ${y(end)} h6" stroke="${AXIS}" stroke-width="1"/>
          <text class="ctxtg" x="${L - 7}" y="${y(start) + 4}" text-anchor="end">${start}</text>
          <text class="ctxtg" x="${L - 7}" y="${y(end) + 4}" text-anchor="end">${end.toFixed(1)}</text>
          <path d="${d}" fill="none" stroke="${S1}" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"/>
          <circle cx="${x(0) + 5}" cy="${y(start) + 0.6}" r="3.6" fill="${S1}"/>
          <circle cx="${x(0.86)}" cy="${y(end)}" r="5" fill="#fff" stroke="${S1}" stroke-width="2"/>
          <text class="ctxtb" x="${W - 1}" y="${y(end) - 22}" text-anchor="end">Target</text>
          <text class="ctxts" x="${W - 1}" y="${y(end) - 11}" text-anchor="end">${esc(targetDate())}</text>
        </svg>
        <div class="cax ink" style="padding-left:${(L / W * 100).toFixed(1)}%">${mo.map(m => `<span>${m}</span>`).join('')}</div>
      </div>`;
    }

    /* ---------- small builders ---------- */
    const optBtn = (k, v, label, on, thumb) =>
      `<button class="opt${thumb ? ' withthumb' : ''}" aria-pressed="${on ? 'true' : 'false'}" onclick="${k}">` +
      (thumb ? `<img class="thumb" src="${thumb}" alt="">` : '') +
      `<span>${esc(label)}</span><span class="tick">${I.check}</span></button>`;

    const ynBlock = (key, q, hint, ill) => `<div class="yn" data-k="${key}">
      ${ill ? `<img class="ynfig" src="${ILL[ill]}" alt="">` : ''}
      <p class="ynq">${esc(q)}${hint ? `<em>${esc(hint)}</em>` : ''}</p>
      <div class="ynrow">
        <button class="ynb" data-v="y" aria-pressed="${ans[key] === 'y'}" onclick="DHQ.setYN('${key}','y')">Yes</button>
        <button class="ynb" data-v="n" aria-pressed="${ans[key] === 'n'}" onclick="DHQ.setYN('${key}','n')">No</button>
      </div></div>`;

    const slot = (title, body) => `<div class="slot"><p><b>${esc(title)}</b>${esc(body)}</p></div>`;
    /* A silent looping clip cut from Duelhawk's own footage. The poster frame covers
       browsers that refuse to autoplay (iOS low power mode, for one). */
    const clip = (k, ratio, pos, zoom) => VID[k] ? `<div class="figwrap" style="aspect-ratio:${ratio || '4/3'};background:#000">
      <video poster="${VID[k].poster}"${vattr(VID[k])} autoplay loop muted playsinline preload="auto"
        style="object-position:${pos || 'center'}${zoom ? ';transform:scale(' + zoom + ')' : ''}">${vsrc(VID[k])}</video></div>`
      : `<div class="figwrap" style="aspect-ratio:${ratio || '4/3'};background:#000">
      <img src="${POSTER[k]}" alt="" style="object-position:${pos || 'center'}${zoom ? ';transform:scale(' + zoom + ')' : ''}"></div>`;
    const photo = (k, ratio, pos) => `<div class="figwrap" style="aspect-ratio:${ratio || '4/3'}">
      <img src="${PH[k]}" alt="" style="object-position:${pos || 'center'}"></div>`;

    /* Media the client placed in the Figma file. Where the motion has been supplied
       as a clip it plays; until then the frame they chose sits in the same slot. */
    const fgMedia = (k, ratio, pos) => VID[k] ? clip(k, ratio, pos)
      : `<div class="figwrap" style="aspect-ratio:${ratio || '4/3'};background:#000"><img src="${FG[k]}" alt="" style="object-position:${pos || 'center'}"></div>`;

    /* Trustpilot's rating strip: 4.7 displays as four and a half stars. In production
       this is the official TrustBox widget, fed by the live score. */
    const tpStars = `<span class="tp" role="img" aria-label="4.7 out of 5 on Trustpilot">${[100, 100, 100, 100, 50].map(f =>
      `<i style="--f:${f}%"><svg viewBox="0 0 24 24"><path fill="#fff" d="M12 3.2l2.7 5.6 6.1.8-4.5 4.3 1.1 6L12 17l-5.4 2.9 1.1-6-4.5-4.3 6.1-.8z"/></svg></i>`).join('')}</span>`;

    const slotOn = (img, title, body) =>
      `<div class="slot onimg"><img src="${img}" alt=""><div class="lbl"><p><b>${esc(title)}</b>${esc(body)}</p></div></div>`;

    const head = showBack => `<div class="head">
      <div class="navrow">${showBack ? `<button class="backb" onclick="DHQ.back()" aria-label="Back">${I.back}</button>` : ''}</div>
      <div class="prog"><i style="width:${Math.round(((cur + 1) / flow().length) * 100)}%"></i></div>
    </div>`;

    const ftr = (label, enabled, onclick) => `<div class="ftr" onclick="DHQ.ftrTap(event)">
      <button class="cta" id="cta" ${enabled ? '' : 'disabled'} onclick="${onclick || 'DHQ.next()'}">${esc(label)}</button>
    </div>`;

    /* ---------- screens ---------- */
    const SCR = {};

    /* Q1: the brief puts the promise, the first question, social proof, the rating and
       the terms line all on the opening screen. */
    SCR.intro = () => `${head(false)}
      <div class="body intro">
        <div class="proof">
          <span class="pitem">${tpStars}<span><b>4.7</b> on Trustpilot</span></span>
          <span class="pdot"></span>
          <span class="pitem"><span><b>20,000+</b> users helped</span></span>
        </div>
        <h1 class="qh">${tx('intro','heading')}</h1>
        <p class="qs">${tx('intro','sub')}</p>
        <p class="qs" style="margin-top:4px"><b>${tx('intro','ask')}</b></p>
        <div class="opts zones">${SPOT.map((o, i) => `<button class="opt"
          aria-pressed="${ans.spot === o[0]}" onclick="DHQ.setOne('spot','${o[0]}')">
          <span class="zf${o[4] == null ? ' whole' : ''}" style="background-image:url('${ILL[o[3]]}');background-position:center ${o[4] == null ? 'center' : o[4] + '%'}"></span>
          <span>${esc(o[1])}</span>
        </button>`).join('')}</div>
        <p class="fine">By clicking an answer you agree to the <a href="${esc(CFG.termsUrl)}" target="_blank" rel="noopener">Terms of Use and Service</a>, <a href="${esc(CFG.privacyUrl)}" target="_blank" rel="noopener">Privacy Policy</a> and <a href="${esc(CFG.cookieUrl)}" target="_blank" rel="noopener">Cookie Policy</a> (including the use of tracking technologies).</p>
      </div>`;

    SCR.spot_other = () => `${head(true)}
      <div class="body">
        <h2 class="qh">${tx('spot_other','heading')}</h2>
        <input class="tin" id="f_spot" placeholder="${tx('spot_other','placeholder')}" value="${esc(ans.spot_other || '')}"
          oninput="DHQ.setText('spot_other',this.value)">
      </div>
      ${ftr('Continue', !!(ans.spot_other || '').trim())}`;

    SCR.height = () => {
      /* the default is a real answer: Continue works without touching the slider */
      if (!ans.height) ans.height = 68;
      const v = ans.height, u = ans.hUnit === 'met' ? 'met' : 'imp', r = H_RANGE[u];
      return `${head(true)}
      <div class="body">
        <h2 class="qh">${tx('height','heading')}</h2>
        <div class="units">
          <button aria-pressed="${ans.hUnit !== 'met'}" onclick="DHQ.setUnit('hUnit','imp')">ft / in</button>
          <button aria-pressed="${ans.hUnit === 'met'}" onclick="DHQ.setUnit('hUnit','met')">cm</button>
        </div>
        <div class="rate" data-set="1" style="margin-top:14px">
          <div class="bignum numrow">${hFields(v)}</div>
          <input type="range" class="slider" min="${r[0]}" max="${r[1]}" step="1" value="${hShown(v)}"
            style="--p:${pct(hShown(v), r)}%" aria-label="Height"
            oninput="DHQ.hSlide(this)">
          <div class="ratelab"><span>${ans.hUnit === 'met' ? '145 cm' : "4'9&quot;"}</span><span>${ans.hUnit === 'met' ? '206 cm' : "6'9&quot;"}</span></div>
        </div>
      </div>
      ${ftr('Continue', true)}`;
    };

    SCR.weight = () => {
      if (!ans.weight) ans.weight = 175;
      const v = ans.weight, u = ans.wUnit === 'met' ? 'met' : 'imp', r = W_RANGE[u];
      return `${head(true)}
      <div class="body">
        <h2 class="qh">${tx('weight','heading')}</h2>
        <div class="units">
          <button aria-pressed="${ans.wUnit !== 'met'}" onclick="DHQ.setUnit('wUnit','imp')">lb</button>
          <button aria-pressed="${ans.wUnit === 'met'}" onclick="DHQ.setUnit('wUnit','met')">kg</button>
        </div>
        <div class="rate" data-set="1" style="margin-top:14px">
          <div class="bignum numrow">${wFields(v)}</div>
          <input type="range" class="slider" min="${r[0]}" max="${r[1]}" step="1" value="${wShown(v)}"
            style="--p:${pct(wShown(v), r)}%" aria-label="Weight"
            oninput="DHQ.wSlide(this)">
          <div class="ratelab"><span>${ans.wUnit === 'met' ? '41 kg' : '90 lb'}</span><span>${ans.wUnit === 'met' ? '181 kg' : '400 lb'}</span></div>
        </div>
      </div>
      ${ftr('Continue', true)}`;
    };

    SCR.sense = () => `${head(true)}
      <div class="body">
        <h2 class="qh">${tx('sense','heading')}</h2>
        <div class="opts">${SENSE.map(o => optBtn(`DHQ.setOne('sense','${o[0]}')`, o[0], o[1], ans.sense === o[0])).join('')}</div>
      </div>`;

    SCR.sense_other = () => `${head(true)}
      <div class="body">
        <h2 class="qh">${tx('sense_other','heading')}</h2>
        <input class="tin" id="f_sense" placeholder="${tx('sense_other','placeholder')}" value="${esc(ans.sense_other || '')}"
          oninput="DHQ.setText('sense_other',this.value)">
      </div>
      ${ftr('Continue', !!(ans.sense_other || '').trim())}`;

    SCR.dur = () => `${head(true)}
      <div class="body">
        <h2 class="qh">${tx('dur','heading')}</h2>
        <div class="opts">${DUR.map(o => optBtn(`DHQ.setOne('dur','${o[0]}')`, o[0], o[1], ans.dur === o[0])).join('')}</div>
      </div>`;

    SCR.intensity = () => {
      if (!ans.intensity) ans.intensity = 5;
      const v = ans.intensity;
      return `${head(true)}
      <div class="body">
        <h2 class="qh">${tx('intensity','heading')}</h2>
        <div class="rate" data-set="1" style="margin-top:8px">
          <div class="bignum">${fmtTen(v)}</div>
          <input type="range" class="slider" min="1" max="10" step="1" value="${v}"
            style="--p:${(v - 1) / 9 * 100}%" aria-label="Discomfort, 1 to 10"
            oninput="DHQ.slide(this,'intensity','fmtTen')">
          <div class="ratelab"><span>1 &middot; ${tx('intensity','low')}</span><span>10 &middot; ${tx('intensity','high')}</span></div>
        </div>
      </div>
      ${ftr('Continue', true)}`;
    };

    SCR.name = () => `${head(true)}
      <div class="body">
        <h2 class="qh">${tx('name','heading')}</h2>
        <input class="tin" id="f_name" placeholder="${tx('name','placeholder')}" value="${esc(ans.name || '')}"
          oninput="DHQ.setText('name',this.value)">
      </div>
      ${ftr('Next', !!(ans.name || '').trim())}`;

    /* Q8 */
    SCR.e_trust = () => `${head(true)}
      <div class="body">
        <h2 class="ih">${esc(name())}, you're in trusted hands</h2>
        <p class="is">You're not alone. We've helped <b>22,653 people</b> with ${esc(spotPre())}discomfort relieve their ${esc(senseIn())}.*</p>
        <div class="figwrap" style="aspect-ratio:1/1;background:#000">
          <img src="${FG.q8}" alt="">
          <div class="vbadge">
            <img class="vstars" src="${FG.bstars}" alt="5 stars">
            <p>20,000+ Happy Customers</p>
          </div>
        </div>
        <p class="fine">*Duelhawk customer survey as of September 2026.</p>
      </div>
      ${ftr('Continue', true)}`;

    SCR.dream = () => `${head(true)}
      <div class="body">
        <h2 class="qh">${tx('dream','heading')}</h2>
        <div class="opts">${DREAM.map(o => optBtn(`DHQ.setOne('dream','${o[0]}')`, o[0], o[1], ans.dream === o[0])).join('')}</div>
      </div>`;

    SCR.dream_other = () => `${head(true)}
      <div class="body">
        <h2 class="qh">${tx('dream_other','heading')}</h2>
        <input class="tin" id="f_dream" placeholder="${tx('dream_other','placeholder')}" value="${esc(ans.dream_other || '')}"
          oninput="DHQ.setText('dream_other',this.value)">
      </div>
      ${ftr('Continue', !!(ans.dream_other || '').trim())}`;

    SCR.tried = () => `${head(true)}
      <div class="body">
        <h2 class="qh">${tx('tried','heading')}</h2>
        <p class="qs">${tx('tried','sub')}</p>
        <div class="opts">${TRIED.map(o =>
          optBtn(`DHQ.toggleMulti('tried','${o[0]}')`, o[0], o[1], (ans.tried || []).includes(o[0]), TRIED_IMG[o[3]])).join('')}</div>
      </div>
      ${ftr('Continue', (ans.tried || []).length > 0)}`;

    /* Q11 */
    SCR.e_habit = () => `${head(true)}
      <div class="body">
        <h2 class="ih">Duelhawk creates <span style="white-space:nowrap">long-term</span> results through daily sitting habits, not irregular or temporary relief like ${esc(triedIn())}.</h2>
        ${chartHabit()}
        <p class="fine">Scientific Reports: 83% of Duelhawk customers interviewed say their pain significantly reduced over a 6-month study.</p>
      </div>
      ${ftr('Got it', true)}`;

    /* Q12 */
    SCR.e_testi = () => `${head(true)}
      <div class="body">
        ${fgMedia('q12', '303/247')}
        <div class="rev">
          <img class="revstars" src="${FG.rstars}" alt="5 stars">
          <div class="revtx">
            <h2 class="revh">I found getting comfortable hard. This chair made it effort-free.</h2>
            <p class="revq">"This chair fits into my lifestyle perfectly. Instead of trying to find time for exercise or expensive chiropractic visits, I just sit and it supports me all day.</p>
            <p class="revq">It's completely effort-free.</p>
            <p class="revq">Unlike temporary relief that fades, the constant daily support really compounds.</p>
            <p class="revq">My back has never felt better, I feel like I got my life back"</p>
          </div>
          <div class="revby">
            <span class="revname">James</span>
            <span class="revver"><img src="${FG.iverified}" alt="">Verified Buyer</span>
          </div>
        </div>
      </div>
      ${ftr('Got it', true)}`;

    /* Q13 */
    const LOAD1 = ['Analysing responses', 'Calculating average time to pain relief', 'Preparing results'];
    SCR.load1 = () => `${head(false)}
      <div class="body">
        <h2 class="ih" style="text-align:center">Be twice as likely to ${esc(dreamIn())} with Ultra 2 vs. trying on your own</h2>
        ${chartTwice()}
        <div class="bigpct" id="p1">0%</div>
        <div class="lbar"><i id="b1" style="width:0%"></i></div>
        <p class="lstatus" id="s1">${esc(LOAD1[0])}&hellip;</p>
        <p class="fine" style="text-align:center">Based on a study over 12 weeks of Duelhawk customers.</p>
      </div>`;

    /* Q14 */
    SCR.email = () => {
      const ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((ans.email || '').trim());
      return `${head(true)}
      <div class="body">
        <h2 class="qh">Enter your email to see how Ultra 2 can help you ${esc(dreamIn())}.</h2>
        <p class="qs">${tx('email','sub')}</p>
        <input class="tin" id="f_email" type="email" inputmode="email" placeholder="${tx('email','placeholder')}" value="${esc(ans.email || '')}"
          oninput="DHQ.setText('email',this.value)">
        <div class="card alt" style="display:flex;gap:10px;align-items:flex-start">
          <span style="font-size:17px;line-height:1">&#127873;</span>
          <p class="qs" style="font-size:13.5px">${tx('email','note',2)}</p>
        </div>
        <p class="fine">By clicking "See My Result" above you acknowledge that you have read, understood, and accepted the <a href="${esc(CFG.termsUrl)}" target="_blank" rel="noopener">Terms of Use</a> and <a href="${esc(CFG.privacyUrl)}" target="_blank" rel="noopener">Privacy Policy</a>.</p>
      </div>
      ${ftr('See My Result', ok)}`;
    };

    /* Q15 */
    SCR.result1 = () => `${head(MODE !== 'res')}
      <div class="body">
        <p class="tagpill"><i></i>The last chair you'll ever need</p>
        <div class="predhd">
          <p class="predlbl">We predict your ${esc(spotPre())}pain will</p>
          <p class="predbig">Decrease <em>71%</em> by ${esc(targetDate())}</p>
        </div>
        ${chartPredict()}
        <p class="is">Great news! Based on Ultra 2 owners like you, we predict you'll be able to conservatively decrease your pain and ${esc(dreamIn())} by ${esc(targetDate())}.</p>
        <p class="is">Next, tell us a bit about your habits and behaviour so we can determine if you can reach your goal sooner.</p>
        <div class="checkline">${I.check2}<span>You've set a good goal for yourself</span></div>
      </div>
      ${ftr('Continue', true)}`;

    /* Q16 */
    SCR.e_goals = () => `${head(true)}
      <div class="body">
        <h2 class="ih">Setting clear goals makes you 3x more likely to achieve them!</h2>
        <p class="is">We'll use your choices to tailor a plan that fits your goals, helping you ${esc(dreamIn())}.</p>
        <div class="plan">
          <p class="cardh">Your plan so far</p>
          <div class="planrow"><span>Goal</span><b>${esc(dreamIn().charAt(0).toUpperCase() + dreamIn().slice(1))}</b></div>
          <div class="planrow"><span>Focus area</span><b>${esc(spotCaps())}</b></div>
          <div class="planrow"><span>Today</span><b>${intensity()} / 10 discomfort</b></div>
          <div class="planrow"><span>Target date</span><b>${esc(targetDate())}</b></div>
        </div>
        <div class="stepper">
          <div class="st done"><i>${I.check}</i><span>Goal set</span></div>
          <div class="st now"><i>2</i><span>Posture check</span></div>
          <div class="st"><i>3</i><span>Your plan</span></div>
        </div>
      </div>
      ${ftr('Continue', true)}`;

    /* Q17 */
    SCR.fit_back = () => `${head(true)}
      <div class="body">
        <p class="eb">${tx('fit_back','eyebrow')}</p>
        <h2 class="qh">${tx('fit_back','heading')}</h2>
        ${ynBlock('flush', tx('fit_back','q1',1), '', 'p_flush')}
        ${ynBlock('recline', tx('fit_back','q2',1), '', 'p_recline')}
      </div>
      ${ftr('Continue', !!(ans.flush && ans.recline))}`;

    /* Q18 */
    SCR.e_back = () => `${head(true)}
      <div class="body">
        <h2 class="ih">You should not be perching on the front edge of the seat.</h2>
        <p class="is">Back support must track directly with your specific spinal curve. That's exactly what the Ultra 2 Posture Fit Rail System&trade; was designed to do!</p>
        ${clip('q18', '304/229')}
        <p class="is">Sitting at a rigid 90-degree angle places maximum downward pressure on spinal discs.</p>
        <p class="is">A slight recline (100 to 110 degrees) transfers that upper-body weight into the backrest.</p>
      </div>
      ${ftr('Got it', true)}`;

    /* Q19 */
    SCR.fit_legs = () => `${head(true)}
      <div class="body">
        <p class="eb">${tx('fit_legs','eyebrow')}</p>
        <h2 class="qh">${tx('fit_legs','heading')}</h2>
        ${ynBlock('feet', tx('fit_legs','q1',1), '', 'p_feet')}
        ${ynBlock('gap', tx('fit_legs','q2',1), '', 'p_gap')}
        ${ynBlock('knees', tx('fit_legs','q3',1), '', 'p_knees')}
      </div>
      ${ftr('Continue', !!(ans.feet && ans.gap && ans.knees))}`;

    /* Q20 */
    SCR.e_legs = () => `${head(true)}
      <div class="body">
        <h2 class="ih">Small misalignments do most of the damage.</h2>
        ${clip('seat', '4/3', 'center 55%')}
        <p class="is">If your heels are lifted or dangling, the seat is too high (or a foot rest is required), which creates pinching and cuts off circulation under the thighs.</p>
        <p class="is">If the seat pan is too long, your body will instinctively slouch forward and bend your knees, completely defeating the purpose of the backrest.</p>
        <p class="is">Dropping your knees slightly opens up the pelvic angle and naturally encourages a healthier lumbar curve.</p>
        ${misfits() > 0 ? `<div class="card alt"><p class="cardh">Your setup</p><p class="is">You flagged <b>${misfits()} of 5</b> alignment checks as not right today. Each one is something the Ultra 2 is adjusted to on your setup call.</p></div>` : ''}
      </div>
      ${ftr('Got it', true)}`;

    /* Q21 */
    SCR.e_adapt = () => `${head(true)}
      <div class="body">
        <h2 class="ih">For sustainable sitting, it's not about forcing yourself into a rigid "perfect" posture. Instead, it's about a workstation that adapts to your natural movements.</h2>
        ${clip('q21', '4/3')}
        <p class="is">In your Personalised Fit Blueprint, we'll dive more into the best ways to align your seat, desk, and monitor to keep you fully supported all day!</p>
      </div>
      ${ftr('Continue', true)}`;

    /* Q22: rolling cards, 4 seconds each, tap to move on */
    /* Third slot is the media for the card: 'vid:<clip>' or 'ph:<photo>'. The first
       card follows the zone the person named: the headrest for a neck answer, the
       rail itself for everything else. */
    const WHY = [
      ['Why Duelhawk is different', 'Ultra 2 was biomechanically designed to support your __SPOT__ with its patented Posture Fit Rail System&reg;.', 'zone'],
      ['Why Duelhawk is different', 'Our support system is based on live, personalised fitting guidance to ensure the best results.', 'vid:q22b'],
      ['Why Duelhawk is different', 'Transform how you feel, simply by sitting.', 'vid:q22c'],
      ['Why Duelhawk is different', "We'll set your chair up with you, so you can focus on living life, not the pain.", 'vid:arm'],
      ['Why Duelhawk is different', 'The best part? All you need to do is sit. No effort needed.', 'ph:room:center 70%'],
      ['Why Duelhawk is different', "Don't worry, we'll be with you every step of the way.", 'ph:desk:center 60%']
    ];
    function whyMedia(m) {
      if (m === 'zone') m = 'vid:spine';   /* 3D render: the spine going from strained to supported as the rail supports engage */
      const [kind, key, pos] = m.split(':');
      if (kind === 'fg') return fgMedia(key, '303/227', pos);
      return kind === 'vid' ? clip(key, '4/3', pos) : photo(key, '4/3', pos);
    }
    SCR.why = () => {
      const b = WHY[Math.min(beat, WHY.length - 1)];
      const last = beat >= WHY.length - 1;
      return `${head(true)}
      <div class="body" onclick="DHQ.nudge()" style="cursor:pointer">
        <div class="beat fade" key="${beat}">
          <p class="beatlbl">${b[0]}</p>
          <h2 class="beath">${b[1].replace('__SPOT__', ans.spot === 'g' ? 'body' : esc(spotIn()))}</h2>
          ${whyMedia(b[2])}
          <div class="dots">${WHY.map((_, i) => `<i data-on="${i <= beat ? 1 : 0}"></i>`).join('')}</div>
        </div>
      </div>
      ${last ? ftr('Continue', true) : ''}`;
    };

    /* Q23 */
    SCR.pay = () => `${head(true)}
      <div class="body">
        <h2 class="qh">${tx('pay','heading')}</h2>
        <div class="opts">${PAY.map(o => optBtn(`DHQ.setOne('pay','${o[0]}')`, o[0], o[1], ans.pay === o[0])).join('')}</div>
      </div>`;

    SCR.thanks = () => `${head(true)}
      <div class="body">
        <h2 class="ih">Thanks for your input, ${esc(name())}.</h2>
        <p class="is">We know you have what it takes to get back to living life fully, and we're personalizing your Ultra 2 plan to build a supportive, pain-free sitting environment that lets you work, exercise, travel, and spend time with family without discomfort and pain holding you back.</p>
        ${clip('recline', '303/227', 'center', 1.32)}
      </div>
      ${ftr('Continue', true)}`;

    /* Q24: the staged analysis, with the two questions the brief interrupts it with */
    const STAGES = [
      ['Biomechanical profile', 'diag'],
      ['Discomfort severity & duration', null],
      ['Workstation & posture alignment', 'workday'],
      ['Data mapping', null],
      ['Ultra 2 rail system configuration', null]
    ];
    SCR.load2 = () => `${head(false)}
      <div class="body">
        <h2 class="ih" style="text-align:center">Building your plan</h2>
        <div class="loadwrap">
          ${STAGES.map((s, i) => `<div class="lrow" data-on="0" id="st${i}">
            <div style="flex:1">
              <div style="display:flex"><span class="lname">${esc(s[0])}</span><span class="lpct" id="sp${i}">0%</span></div>
              <div class="lbar"><i id="sb${i}" style="width:0%"></i></div>
            </div></div>`).join('')}
        </div>
        <p class="fine" style="text-align:center">Sit tight! We're building your perfect plan based on thousands of data points from successful Ultra 2 users.</p>
      </div>
      <div id="intwrap"></div>`;

    const INTQ = {
      diag: [tx('diag','heading',1), tx('diag','hint',1), [tx('diag','yes',1), tx('diag','no',1)], ['y', 'n']],
      workday: [tx('workday','heading',1), '', [tx('workday','yes',1), tx('workday','no',1)], ['seated', 'active']]
    };
    function askInterrupt(key) {
      const q = INTQ[key];
      const w = $('intwrap');
      if (!w) return;
      w.innerHTML = `<div class="interrupt"><div class="box">
        <p class="ynq" style="font-size:17px;font-weight:500">${esc(q[0])}${q[1] ? `<em>${esc(q[1])}</em>` : ''}</p>
        <div class="ynrow">
          <button class="ynb" onclick="DHQ.answerInterrupt('${key}','${q[3][0]}')">${esc(q[2][0])}</button>
          <button class="ynb" onclick="DHQ.answerInterrupt('${key}','${q[3][1]}')">${esc(q[2][1])}</button>
        </div></div></div>`;
    }
    function answerInterrupt(key, v) {
      ans[key] = v;
      commitKey('load2', key);
      const w = $('intwrap');
      if (w) w.innerHTML = '';
      runLoad2();
    }

    /* Q25: the offer reveal, 3 seconds a card */
    function revealCards() {
      return [
        `Based on your answers, ${esc(name())}&hellip;`,
        "We've created a personalised plan",
        `With additional focus on your ${esc(spotIn())}<br>Designed to reduce discomfort by <em style="font-style:normal;color:var(--s1t)">71%</em> by ${esc(targetDate())}`,
        "Let's get started."
      ];
    }
    SCR.reveal = () => {
      const cards = revealCards();
      const last = beat >= cards.length - 1;
      return `${head(MODE !== 'res')}
      <div class="body" onclick="DHQ.nudge()" style="cursor:pointer">
        <div class="beat fade" key="${beat}">
          <h2 class="beath">${cards[Math.min(beat, cards.length - 1)]}</h2>
        </div>
      </div>
      ${last ? ftr('Continue', true) : ''}`;
    };

    /* Q26: the prediction reveal, 2 seconds a card, chart on the last one */
    function predictCards() {
      return [
        ['We predict you\'ll be in', `<em>71%</em> less discomfort by ${esc(targetDate())}`, false],
        ['And', 'Get back to enjoying life, exercising, working, activities and spending time with the people you care about without discomfort holding you back.', false],
        ['Change for good', "After the pain has been reduced, we'll use the final 2 weeks of your program to build healthy habits so the discomfort doesn't come back!", true]
      ];
    }
    SCR.predict = () => {
      const cards = predictCards();
      const b = cards[Math.min(beat, cards.length - 1)];
      const last = beat >= cards.length - 1;
      return `${head(true)}
      <div class="body" onclick="DHQ.nudge()" style="cursor:pointer">
        <div class="beat fade" key="${beat}" style="${b[2] ? 'justify-content:flex-start;padding-top:4px' : ''}">
          <p class="beatlbl">${b[0]}</p>
          <h2 class="beath">${b[1]}</h2>
          ${b[2] ? chartPredict() : ''}
        </div>
      </div>
      ${last ? ftr('Continue', true) : ''}`;
    };

    /* Q27: the offer, laid out as in the client's Figma. */
    const INCLUDES = [
      ['Duelhawk Ultra 2 Chair', 'Patented Posture Fit Rail System&reg; and 12-year warranty', '', 'oft1'],
      ...(DISCOUNT ? [[money(DISCOUNT) + ' discount', 'Reserve today and pay ' + money(PRICE) + ' instead of ' + money(PRICE_FULL), money(DISCOUNT), null]] : []),
      ['Personalised Fit Blueprint', 'Tailored to your height, weight and discomfort pattern', '$500', 'oft2'],
      ['Live 1-on-1 Ultra 2 setup session', 'Guided call within 24hrs of delivery: height, depth and rail alignment', '$750', 'oft3'],
      ['Workstation Alignment Checklist', 'Complete desk and monitor positioning guide', '$250', 'oft4']
    ];
    SCR.offer = () => `${head(MODE !== 'res')}
      <div class="body offer">
        <div class="ofhero">
          <img src="${FG.ofhero}" alt="Duelhawk Ultra 2">
          <span class="ofpill"><img src="${FG.icheck}" alt="">${(ans.name || '').trim() ? 'Reserved for ' + esc(name()) : 'Your plan is ready'}</span>
          <span class="ofpill ofdeliv"><svg viewBox="0 0 24 24" fill="none" stroke="#17907F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h13v10H1zM14 10h4l3 3v3h-7z"/><circle cx="5.5" cy="17.5" r="2"/><circle cx="17.5" cy="17.5" r="2"/></svg>Est. delivery date ${deliveryDate()}</span>
        </div>
        <div class="ofhead">
          <p class="tagpill left"><i></i>Your personalised plan</p>
          <h2 class="ofh">The Ultra 2 Support System</h2>
          <div class="checkline">${I.check2}<span>Reduce your ${esc(spotPre())}discomfort by ${esc(targetDate())}</span></div>
          <div class="checkline">${I.check2}<span>${esc(dreamIn().charAt(0).toUpperCase() + dreamIn().slice(1))}</span></div>
        </div>
        ${ans.diag === 'y' ? `<div class="card alt"><p class="is" style="font-size:14px">You told us you've had a diagnosed spinal condition or back surgery. This quiz is an estimate from your own answers, not a medical assessment, so please run any change to your seating past your clinician first.</p></div>` : ''}
        <div class="ofbox">
          <p class="ofsec">Your personalized system includes</p>
          <div class="ofrows">
          ${INCLUDES.map(r => `<div class="ofrow">
            ${r[3] ? `<img src="${FG[r[3]]}" alt="">` : `<span class="ofsave">${r[2]}</span>`}
            <div class="oftx"><div class="incn">${r[0]}</div><div class="incd">${r[1]}</div></div>
            ${r[2] ? `<div class="ofval">${r[3] ? `<em>FREE</em><s>${r[2]}</s>` : '<em>OFF</em>'}</div>` : ''}</div>`).join('')}
          </div>
          <div class="oftotal"><span>Bonuses included</span><span>${money(1500 + DISCOUNT)} value</span></div>
        </div>
        <div class="ofprice">
          <p class="pricelbl">${esc(CFG.priceLabel || 'Early Black Friday sale')}</p>
          ${DISCOUNT ? `<p class="pricewas"><s>${money(PRICE_FULL)}</s><span>${money(DISCOUNT)} off</span></p>` : ''}
          <div class="pricebig">${money(PRICE)}</div>
          <p class="pricealt">or ${money(DEPOSIT)} today, then ${money(Math.ceil(REMAINING / 12))}/mo for 12 months at 0% financing</p>
          <img class="ofcut" src="${FG.ofcut}" alt="">
        </div>
        <div class="guar">
          <div class="gl"><img src="${FG.iguar}" alt=""><b>90-DAY</b><span>GUARANTEE</span></div>
          <div><p class="gt">Fit &amp; Support System Guarantee</p><p class="gd">Set up with you on a live call, then adjusted until it fits.</p></div>
        </div>
        <div class="guar">
          <div class="gl"><svg class="gcal" viewBox="0 0 30 30" fill="none" stroke="#224347" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="6" width="22" height="20" rx="3"/><path d="M4 12h22M10 3.5v5M20 3.5v5M11 19l3 3 5.5-6"/></svg><b>30-DAY</b><span>FIT SUPPORT</span></div>
          <div><p class="gt">30-Day Fit Optimisation</p><p class="gd">We check in on days 3, 14, and 30 to make fine adjustments so you never have to guess or suffer through posture fatigue.</p></div>
        </div>
        <div class="gj">
          <p class="gjh"><img src="${FG.ithumb}" alt="">Great job!</p>
          <p class="gjt">We know dealing with pain and discomfort is hard, but you're on the right track. Only 1 out of 8 people make it this far. <b>Continue your ${esc(spotPre())}relief journey by signing up for your personalised plan today</b>.</p>
        </div>
        ${chartPredict()}
      </div>
      <div class="ftr payftr">
        <div class="paysum">
          <div><span>Total</span><b>${DISCOUNT ? `<s>${money(PRICE_FULL)}</s>` : ''}${money(PRICE)}</b></div>
          <div class="due"><span>Due today</span><b>${money(DEPOSIT)}</b></div>
        </div>
        <p class="psnote"><b>Reserve your Ultra 2 support system for ${money(DEPOSIT)} today to get your ${DISCOUNT ? 'discount and ' : ''}bonuses.</b> Your refundable ${money(DEPOSIT)} deposit is credited toward the total purchase price. We'll contact you to complete your order before your chair is shipped.</p>
        <button class="cta" id="cta" onclick="DHQ.checkout()">Secure with $199 initial payment</button>
      </div>`;

    /* Q27b: reinforce the purchase and book the setup call */
    const NEXT = [
      ['Bespoke configuration', 'Our team is reviewing your quiz responses to prepare your custom Personalised Fit Blueprint.'],
      ['Shipment dispatch', 'Your system ships quickly with all necessary tools and clear setup instructions included.'],
      ['Guided live setup call', 'During your 15-minute video session we align your seat height, depth, back support and monitor placement, and talk through your pain points.'],
      ['30-day fit optimisation', 'We check in on days 3, 14, and 30 to make fine adjustments so you never have to guess or suffer through posture fatigue.']
    ];
    SCR.reserved = () => `${head(true)}
      <div class="body">
        <h2 class="ih">Congratulations${(ans.name || '').trim() ? ' ' + esc(name()) : ''}! Your Ultra 2 Support System is reserved.</h2>
        <p class="is">You've taken the biggest step toward sitting comfortably and getting back to ${esc(dreamIng())}.</p>
        <div class="figwrap" style="aspect-ratio:303/227;background:#000">
          ${VID.q28 ? `<video poster="${VID.q28.poster}"${vattr(VID.q28)} autoplay loop muted playsinline preload="auto">${vsrc(VID.q28)}</video>` : `<img src="${POSTER.q28}" alt="">`}
          <span class="ofpill"><img src="${FG.icheck}" alt="">Order reserved</span>
        </div>
        <p class="eb">Step 1 of 2</p>
        <h3 class="ih" style="font-size:19px">Choose your live setup appointment.</h3>
        <p class="is">Your Ultra 2 arrives mostly pre-assembled. To get maximum support for your height${ans.height ? ' (' + fmtHeight(ans.height).replace(/<[^>]+>/g, '') + ')' : ''} and your ${esc(spotIn())}, our specialists need 15 minutes to help you align seat depth, desk height and the Posture Fit Rail System&reg;.</p>
        ${CFG.bookingUrl && CFG.bookingEmbed ? `<div class="calslot cal-live"><div class="iclosed-widget" data-url="${esc(CFG.bookingUrl)}" title="Book your live setup call" style="width:100%;height:620px"></div><div class="calload" role="status"><span class="calspin" aria-hidden="true"></span><p>Loading available times&hellip;</p><p class="calslow" hidden>Taking longer than usual? <a href="${esc(CFG.bookingUrl)}" target="_blank" rel="noopener">Open the calendar</a></p></div></div>` : ''}
        <p class="eb" style="margin-top:6px">Step 2 of 2 &middot; What happens next</p>
        <div class="steps">
          ${NEXT.map((s, i) => `<div class="step${i === 0 ? ' on' : ''}">
            <div class="dot">${i + 1}</div>
            <div><div class="stepn">${s[0]}${i === 0 ? ' <span style="color:var(--mute);font-weight:400">(in progress)</span>' : ''}</div><div class="stepd">${s[1]}</div></div>
          </div>`).join('')}
        </div>
        <div class="card alt">
          <p class="cardh">Your order summary</p>
          <div class="checkline" style="margin-bottom:7px">${I.check2}<span>Duelhawk Ultra 2 Back-Support System</span></div>
          ${DISCOUNT ? `<div class="checkline" style="margin-bottom:7px">${I.check2}<span>${money(DISCOUNT)} discount: you pay ${money(PRICE)} instead of ${money(PRICE_FULL)}</span></div>` : ''}
          <div class="checkline" style="margin-bottom:7px">${I.check2}<span>Free bonus 1: Personalised Fit Blueprint ($500 value)</span></div>
          <div class="checkline" style="margin-bottom:7px">${I.check2}<span>Free bonus 2: 1-on-1 live Ultra 2 setup session ($750 value)</span></div>
          <div class="checkline" style="margin-bottom:7px">${I.check2}<span>Free bonus 3: Workstation Alignment Checklist ($250 value)</span></div>
          <div class="checkline">${I.check2}<span>Free bonus 4: 30-day fit optimisation support ($750 value)</span></div>
        </div>
      </div>
      ${CFG.bookingUrl ? ftr('Book my setup call', true, 'DHQ.book()') : ''}`;

    /* ---------- beat sequences ---------- */
    const BEATS = { why: [WHY.length, 4000], reveal: [4, 3000], predict: [3, 2000] };
    function nudge() {
      const id = flow()[cur];
      const cfg = BEATS[id];
      if (!cfg) return;
      clearTimers();
      if (beat < cfg[0] - 1) { beat++; render(); } else { next(); }
    }
    /* The brief's interval is the floor. A longer card gets reading time on top:
       about a quarter second a word plus a beat to take it in. */
    function runBeats(id) {
      const cfg = BEATS[id];
      if (!cfg) return;
      if (beat >= cfg[0] - 1) return;
      const card = $('scr').querySelector('.beat');
      const words = card ? (card.innerText || '').trim().split(/\s+/).filter(Boolean).length : 0;
      const wait = Math.max(cfg[1], 1500 + words * 230);
      later(() => { if (flow()[cur] === id) { beat++; render(); } }, wait);
    }

    /* ---------- loaders ---------- */
    function runLoad1() {
      let p = 0;
      const at = cur;
      const tick = () => {
        if (flow()[cur] !== 'load1' || cur !== at) return;
        p = Math.min(100, p + 1);
        const el = $('p1'), bar = $('b1'), st = $('s1');
        if (!el) return;
        el.textContent = p + '%';
        bar.style.width = p + '%';
        st.innerHTML = esc(LOAD1[Math.min(LOAD1.length - 1, Math.floor(p / 34))]) + '&hellip;';
        if (p >= 100) { later(() => { if (cur === at) next(); }, 500); return; }
        later(tick, 58);
      };
      later(tick, 120);
    }

    /* The staged loader pauses on the two stages the brief attaches a question to. */
    let l2stage = 0, l2pct = 0;
    function runLoad2() {
      const at = cur;
      const tick = () => {
        if (flow()[cur] !== 'load2' || cur !== at) return;
        if (l2stage >= STAGES.length) { later(() => { if (cur === at) next(); }, 450); return; }
        const key = STAGES[l2stage][1];
        if (key && !ans[key] && l2pct >= 60) { askInterrupt(key); return; }
        l2pct = Math.min(100, l2pct + 4);
        const row = $('st' + l2stage), pct = $('sp' + l2stage), bar = $('sb' + l2stage);
        if (!row) return;
        row.dataset.on = '1';
        pct.textContent = l2pct + '%';
        bar.style.width = l2pct + '%';
        if (l2pct >= 100) { l2stage++; l2pct = 0; }
        later(tick, 42);
      };
      later(tick, 120);
    }

    /* ---------- render ---------- */
    function refreshCta() {
      const id = flow()[cur];
      const btn = $('cta');
      if (!btn) return;
      const ok = {
        spot_other: () => !!(ans.spot_other || '').trim(),
        sense_other: () => !!(ans.sense_other || '').trim(),
        dream_other: () => !!(ans.dream_other || '').trim(),
        name: () => !!(ans.name || '').trim(),
        height: () => !!ans.height,
        weight: () => !!ans.weight,
        intensity: () => !!ans.intensity,
        tried: () => (ans.tried || []).length > 0,
        fit_back: () => !!(ans.flush && ans.recline),
        fit_legs: () => !!(ans.feet && ans.gap && ans.knees),
        email: () => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((ans.email || '').trim())
      }[id];
      if (ok) btn.disabled = !ok();
    }

    function render() {
      clearTimers();
      const f = flow();
      if (cur >= f.length) cur = f.length - 1;
      const id = f[cur];
      currentId = id;
      const fn = SCR[id];
      $('scr').innerHTML = `<div class="qv">${fn ? fn() : '<div class="body"><p class="is">Missing screen: ' + esc(id) + '</p></div>'}</div>`;

      $('scr').querySelectorAll('video').forEach(v => {
        v.muted = true;
        const p = v.play();
        if (p && p.catch) p.catch(() => {});   /* blocked autoplay just leaves the poster up */
        attachHls(v);
      });

      fitAll();

      /* keep focus in a text field so typing does not need a second tap */
      const inp = $('scr').querySelector('.tin');
      if (inp) inp.focus();

      if (id === 'load1') { runLoad1(); }
      if (id === 'load2') { l2stage = 0; l2pct = 0; runLoad2(); }
      if (BEATS[id]) runBeats(id);
      if (jumpSel) jumpSel.value = id;
      emit(id);
    }

    /* Our own browsers (?dhq_internal=1) get a screen picker so a test can start at
       any step; ?dhq_jump=offer opens straight on one. Unanswered questions before
       that step take a sample profile so it renders as for a real visitor; the
       step's own question stays open. Email stays empty, so the checkout link
       carries none. */
    const SAMPLE = {spot: 'a', height: 68, weight: 175, sense: 'd', dur: 'c', intensity: 7, name: 'Test',
                    dream: 'a', tried: ['a', 'b'], flush: 'n', recline: 'y', feet: 'y', gap: 'n', knees: 'y',
                    diag: 'n', workday: 'seated', pay: 'a'};
    const OTHER = {spot_other: ['spot', 'g'], sense_other: ['sense', 'f'], dream_other: ['dream', 'f']};
    /* diag and workday are asked inside the second loading screen */
    const ASKED_ON = Object.assign({diag: 'load2', workday: 'load2'},
      ...Object.keys(SCREEN_Q).map(s => Object.fromEntries(SCREEN_Q[s].map(k => [k, s]))));
    let jumpSel = null;
    function jump(id) {
      const at = ORDER.indexOf(id);
      Object.keys(SAMPLE).forEach(k => { if (ans[k] == null && ORDER.indexOf(ASKED_ON[k]) < at) ans[k] = SAMPLE[k]; });
      if (OTHER[id]) ans[OTHER[id][0]] = OTHER[id][1];
      const i = flow().indexOf(id);
      if (i < 0) return;
      cur = i;
      beat = 0;
      render();
    }
    function mountJump() {
      const box = document.createElement('div');
      box.className = 'dhqjump';
      box.innerHTML = `<label for="dhqjump">Test</label><select id="dhqjump">${ORDER.map((k, i) => `<option value="${k}">${i + 1}. ${k}</option>`).join('')}</select>`;
      root.appendChild(box);
      jumpSel = box.querySelector('select');
      jumpSel.addEventListener('change', () => jump(jumpSel.value));
    }


    /* ---------------- bootstrap ---------------- */
    Object.assign(DHQ, {setOne: setOne, next: next, back: back, go: go, toggleMulti: toggleMulti, setYN: setYN, setText: setText, slide: slide, hSlide: hSlide, hTyped: hTyped, hSync: hSync, wSlide: wSlide, wTyped: wTyped, wSync: wSync, setUnit: setUnit, nudge: nudge, answerInterrupt: answerInterrupt, fmtTen: fmtTen, ftrTap: ftrTap});
    /*@DHQ_TEST_HOOK@*/
    track('page_view', {});
    var step = (location.search.match(/[?&]step=([a-z_0-9]+)/) || [])[1];
    /* The reserved screen opens from the link even on another device (an email
       after payment): saved answers personalise it when this browser has them. */
    var jumpTo = INTERNAL && (location.search.match(/[?&]dhq_jump=([a-z_0-9]+)/) || [])[1];
    if (INTERNAL) mountJump();
    if (step === 'reserved') { restoreState(); go(flow().indexOf('reserved')); }
    else if (jumpTo && ORDER.indexOf(jumpTo) >= 0) jump(jumpTo);
    else go(0);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-dhq]');
    for (var i = 0; i < roots.length; i++) boot(roots[i]);
  }
  /* The script tag is async and sits after the section markup, so the quiz is
     already in the page when this runs: start now rather than after the store's
     deferred scripts, which on a phone hold DOMContentLoaded back by seconds. The
     DOMContentLoaded pass only picks up a quiz parsed later; boot() skips one
     already running. */
  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  /* Theme editor re-renders the section on every settings change. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
